import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useAppDispatch, useAppSelector } from '@/store/hook'
import {
  getSelectedMachineData,
  selectSubmitServiceData,
  selectSubmitServiceResponse,
} from '@/store/selectors/serviceCaseSelector'
import {
  setSelectedMachineInfo,
} from '@/store/slices/serviceCaseSlice'
import useAdobeAnalysis from '@/hooks/useAdobeAnalysis'
import useBreadcrumbs from '@/hooks/useBreadcrumbs'
import useDocumentTitle from '@/hooks/useDocumentTitle'
import { PAGE_TYPES } from '@/libs/constants/adobeAnalytics'
import { linkGenerator } from '@/libs/utils/language'

import RequestServiceConfirmation from './RequestServiceConfirmation'

const RequestServiceConfirmationPage = ({ breadcrumbs }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useBreadcrumbs(breadcrumbs)
  useDocumentTitle('pageTitle.confirmService')

  useAdobeAnalysis(null, {
    pageId: '21',
    pageName: 'request service confirmation',
    pageType: PAGE_TYPES.CONFIRMATION,
  })

  const submitServiceResponse = useAppSelector(selectSubmitServiceResponse)
  const submitServiceData = useAppSelector(selectSubmitServiceData)
  const selectedMachineData = useAppSelector(getSelectedMachineData)

  const { serviceEntry } = selectedMachineData

  useEffect(() => {
    if (submitServiceResponse && submitServiceData) {
      if (
        Object.keys(submitServiceResponse).length === 0
        || Object.keys(submitServiceData).length === 0
      ) {
        // Data is missing - redirect back to service request page
        // This handles cases where user navigates directly to confirmation page
        dispatch(
          setSelectedMachineInfo({
            serviceEntry,
            isChangedService: true,
          }),
        )

        navigate(linkGenerator('/request-services'), { replace: true })
      }
    }
  }, [
    submitServiceResponse,
    submitServiceData,
    serviceEntry,
    dispatch,
    navigate,
  ])

  return (
    <div className="request-service-confirmation">
      <RequestServiceConfirmation
        data={submitServiceData}
        responseData={submitServiceResponse}
      />
    </div>
  )
}

export default RequestServiceConfirmationPage
